<app-orders-list
  [title]="title"
  [emptyMessage]="emptyMessage"
  [estimates]="orders()"
  [loading]="loading()"
  [error]="error()"
></app-orders-list>
